import { useEffect, useRef, useState } from 'react';

interface BeforeInstallPromptEvent extends Event {
    readonly platforms: Array<string>;
    readonly userChoice: Promise<{
        outcome: 'accepted' | 'dismissed';
        platform: string;
    }>;
    prompt(): Promise<void>;
}

const useBeforeInstallPrompt = () => {
    const installPromptRef = useRef<BeforeInstallPromptEvent | null>(null);
    const [choiceResult, setChoiceResult] = useState<{ outcome: 'accepted' | 'dismissed' | null, platform: string } | null>(null);
    const [isPromptEvent, setIsPromptEvent] = useState(false);
    const [showInstallButton, setShowInstallButton] = useState(
        () => JSON.parse(localStorage.getItem('showInstallButton') || 'false')
    );

    useEffect(() => {
        const handleBeforeInstallPrompt = (event: Event) => {
            event.preventDefault();
            installPromptRef.current = event as BeforeInstallPromptEvent;
            setIsPromptEvent(true);
            setShowInstallButton(true);
            localStorage.setItem('showInstallButton', 'true');
        };

        window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);

        return () => {
            window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
        };
    }, []);

    const handleInstallClick = async () => {
        const currentInstallPrompt = installPromptRef.current;

        if (currentInstallPrompt) {
            try {
                await currentInstallPrompt.prompt();
                const result = await currentInstallPrompt.userChoice;
                setChoiceResult(result);

                if (result.outcome === 'dismissed') {
                    setShowInstallButton(true);
                    localStorage.setItem('showInstallButton', 'true');
                } else {
                    setShowInstallButton(false);
                    localStorage.setItem('showInstallButton', 'false');
                }
            } catch (error) {
                console.error('Ошибка во время установки PWA:', error);
            } finally {
                installPromptRef.current = null;
                setIsPromptEvent(false);
            }
        }
    };

    return { handleInstallClick, choiceResult, isPromptEvent, showInstallButton };
};

export default useBeforeInstallPrompt;

